export { default } from './CatalogContent';
